var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.91755,
    y1: 1079.08427,
    x2: 8.50157,
    y2: 1073.53379,
    gradientTransform: "translate(-81.82204 89732.01645) scale(82.82204 -83.00742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#387eb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.00436,
    y1: 1075.86419,
    x2: 12.0076,
    y2: 1070.17956,
    gradientTransform: "translate(-52.95663 89760.16348) scale(82.81982 -83.00746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc331"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.63362,74.22463c-237.715,0-222.89973,103.08641-222.89973,103.08641l.25992,106.80071h226.88233v32.0704H223.94517s-152.14364-17.24676-152.14364,222.60628,132.77564,231.36798,132.77564,231.36798h79.24113v-111.30309s-4.26768-132.77562,130.65436-132.77562h224.98746s126.41183,2.04579,126.41183-122.16934v-205.35959s19.20039-124.32414-229.23832-124.32414ZM411.54651,146.04555c22.51854.02166,40.75585,18.2941,40.73417,40.81263-.02165,22.51853-18.29409,40.75585-40.81263,40.73418s-40.75582-18.2941-40.73417-40.81263c.01039-10.80158,4.30646-21.15765,11.94507-28.79477,7.65589-7.65438,18.04157-11.94983,28.86756-11.93941Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.38311,1005.77537c237.72336,0,222.88297-103.12836,222.88297-103.12836l-.2599-106.8007h-226.85718v-32.02847h316.93094s152.11853,17.25512,152.11853-222.61469-132.77562-231.35963-132.77562-231.35963h-79.21596v111.30316s4.26769,132.77562-130.65438,132.77562h-224.9959s-126.41189-2.04583-126.41189,122.17772v205.41823s-19.15839,124.25713,229.23839,124.25713ZM668.47022,933.96281c-22.52314-.0151-40.76958-18.28603-40.75442-40.80917.0151-22.52314,18.28596-40.76951,40.80911-40.75442,22.52314.0151,40.76958,18.28603,40.75448,40.80917-.00729,10.80497-4.30217,21.16549-11.94162,28.80659-7.65448,7.65748-18.04039,11.95601-28.86756,11.94782Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.1140ec3ea664e6e04815664a420f1f83.svg";
export { ForwardRef as ReactComponent };